import React, { useEffect, useState } from "react";

import SpaceIcon from "../../ui/SpaceIcon";
import PhotoSliderFullscreen from "../../PhotoSliderFullscreen";

import "./bookingNumberVariant.scss";

function BookingNumberVariant({
  id,
  title,
  description,
  photos,
  separate = false,
  is_selected = false,
  space = 0,
  url,
  setNumber,
  freeze = false,
}) {
  const [selected, setSelected] = useState(is_selected);

  useEffect(() => {
    setSelected(is_selected ? true : false);
  }, [is_selected]);

  const selectHandler = (e) => {
    if (freeze && selected) {
      // запрещено снимать выделение с номера
      return;
    }
    const new_state = !selected;
    setNumber(new_state ? id : null);
    setSelected(new_state);
  };

  if (!separate) {
    return null;
  }

  return (
    <div className="bookingNumberVariant">
      <PhotoSliderFullscreen
        base_url={url}
        photos={photos}
        noAva="/empty.jpg"
      />
      <div className="bookingNumberVariant__header dfsp">
        <h3 className="textLimit fg1">{title}</h3>
        <div className="bookingNumberVariant__check">
          <input
            type="checkbox"
            id={`v_${id}`}
            className="customRadioCheck"
            name="variant"
            checked={selected}
            onChange={selectHandler}
          />
          <label htmlFor={`v_${id}`}></label>
          {space > 0 && (
            <span className="bookingNumberVariant__space">
              <SpaceIcon size={16} /> {space} м<sup>2</sup>
            </span>
          )}
        </div>
      </div>
      {description && (
        <div className="bookingNumberVariant__footer">{description}</div>
      )}
    </div>
  );
}

export default BookingNumberVariant;
